var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import Card from "../../templates/Card";
var StyledLogin = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizeing: border-box;\n  width: 500px;\n  max-width: calc(100% - ", "px);\n  margin: 0 auto;\n  padding: 20vh 0 50px;\n"], ["\n  box-sizeing: border-box;\n  width: 500px;\n  max-width: calc(100% - ", "px);\n  margin: 0 auto;\n  padding: 20vh 0 50px;\n"])), function (props) { return props.theme.spacing * 4; });
export default (function (props) {
    return (_jsx(StyledLogin, { children: _jsx(Card, { children: props.children }) }));
});
var templateObject_1;
//# sourceMappingURL=index.js.map